var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /home/buzius/projects/easyflow-docker/workspace/easyflow/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d97668f2","hasScoped":false,"buble":{"transforms":{}}}!/home/buzius/projects/easyflow-docker/workspace/easyflow/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 129
// module chunks = 0